import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const HeroContent = () => {
  return (
    <div className="flex flex-col w-full sm:w-2/3">
      <div className="2xl:text-xl">24/7 Live Chat with AI-Powered Support</div>
      <h1 className="text-3xl sm:text-5xl mb-3 font-semibold">
        Increase Business <br /> with Automated AI Support
      </h1>
      <p className="">
        Instantly connect with customers using an AI chatbot that works around
        the clock. Answer questions, capture leads, and improve customer
        experience—all without extra effort.
        <strong>
          {" "}
          Get started in three easy steps: Create, Train, and Deploy. No coding
          needed!
        </strong>
      </p>
      <motion.div
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="mt-5 ">
        <Link
          onClick={() => {
            localStorage.setItem("renderCountPlan", JSON.stringify(1));
            localStorage.setItem("selectedCurrency", "USD");
          }}
          to={!true ? "/signup" : "/login"}>
          <div className="relative inline-block">
            <div className="absolute bottom-2 h-4 w-full translate-y-full rounded-b-lg bg-gradient-to-r from-[#FB923C] via-[#F472B6] to-[#E879F9]"></div>
            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors relative h-fit w-fit rounded-md py-4 px-10 before:bg-gradient-to-r before:from-[#E879F9] before:via-[#F472B6] before:to-[#FB923C] bg-zinc-950 text-white hover:bg-primarydark ">
              Build Your Chatbot
            </button>
          </div>
        </Link>
      </motion.div>{" "}
    </div>
  );
};

export default HeroContent;
